const getTranslation = label => {
  switch (label) {
    case 'Equipo Artístico':
      return 'Creative team';
    case 'Regisseur':
      return 'Stage Director';
    case 'Vestuarista':
      return 'Costume Designer';
    case 'Iluminador':
      return 'Lighting Designer';
    case 'Multimedia':
      return 'Multimedia';
    case 'Escenógrafo':
      return 'Scenic Designer';
    case 'Coreógrafo':
      return 'Choreographer';
    default:
      break;
  }

  return '';
};

export default getTranslation;



// WEBPACK FOOTER //
// ./src/utils/GetTranslation.js